<h1 mat-dialog-title class="dialog-title-with-action">
    {{ dialogTitle }}
    <button mat-icon-button mat-dialog-close>
        <mat-icon>clear</mat-icon>
    </button>
</h1>
<mat-dialog-content>
    <fieldset>
        <legend>Employee</legend>
        <div [formGroup]="employeeFormGroup" class="employee-dialog-content">
            <mat-form-field>
                <mat-label>Atlassian account id</mat-label>
                <input matInput formControlName="atlassianAccountId" />
                <mat-error
                    *ngIf="employeeFormGroup.controls.atlassianAccountId.hasError('duplicateAtlassianAccountId')">
                    This Atlassian Account ID is already taken.
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>First name</mat-label>
                <input matInput formControlName="firstName" required />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Last name</mat-label>
                <input matInput formControlName="lastName" required />
            </mat-form-field>
        </div>
    </fieldset>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" mat-dialog-close>
        <span>Cancel</span>
    </button>
    <button
        mat-flat-button
        [color]="crud !== 4 ? 'primary' : 'warn'"
        [disabled]="
            (isDelete && !employeeFormGroup.pristine) ||
            (!isDelete && employeeFormGroup.pristine) ||
            (!isDelete && !employeeFormGroup.valid)
        "
        (click)="action()">
        <span *ngIf="crud === 1 || crud === 3">Save</span>
        <span *ngIf="crud === 4">Delete</span>
    </button>
</mat-dialog-actions>
